module.exports = __webpack_public_path__ + "img/map2_seoul_sang.692cd84c.jpg";